// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional', 'colaborador_satya']


const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Tipos de Arquivo',
    to: 'TipoArquivoList'
  }
]

export default [
  {
    path: '/tipoArquivo',
    name: 'TipoArquivoList',
    component: () => import('@/views/TipoArquivo/TipoArquivoListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Tipos de Arquivo',
      breadcrumb: breadCrumb
    },
  },
  {
    path: '/tipoArquivo/novo',
    name: 'NovoTipoArquivo',
    component: () => import('@/views/TipoArquivo/TipoArquivoFormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Tipo de Arquivo',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Novo Tipo de Arquivo',
          to: 'NovoTipoArquivo'
        }
      ]
    }
  },
  {
    path: '/tipoArquivo/:id/edit',
    name: 'NovoTipoArquivoEdit',
    component: () => import('@/views/TipoArquivo/TipoArquivoFormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Detalhes',
          to: 'NovoTipoArquivo'
        }
      ]
    }
  },
];